exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".advance-search-wrapper .ant-form-item{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:24px;margin-right:0}.advance-search-wrapper .ant-form-item>.ant-form-item-label{padding-right:8px;width:auto}.advance-search-wrapper .ant-form-item>.ant-form-item-control-wrapper{-webkit-box-flex:1;-ms-flex:1 1;flex:1 1}.advance-search-wrapper .action-button-zone .ant-btn:not(:last-of-type){margin-right:8px}", ""]);

// exports
